


















































import { Vue, Component } from "vue-property-decorator";
import { $auth } from "@/services/AuthenticationService";
import { $layout } from "@/services/LayoutService";

@Component
export default class AgAppBar extends Vue {
  get isAdmin() {
    return $auth.currentUser?.roles?.some((role: any) => role.includes('ADMIN'));
  }

  get currentUser() {
    return $auth.currentUser;
  }

  logout() {
    $auth.logout();
  }

  goToAdmin() {
    this.$router.push({ path: "/admin/users" });
  }

  goToProfile() {
    this.$router.push({ path: "/my/profile" });
  }

  get drawer() {
    return $layout.drawer;
  }

  set drawer(val) {
    $layout.drawer = val;
  }
}
